// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  region: 'eu-west-1',
  identityPoolId: 'eu-west-1:cd5f1011-3122-4598-94a1-0071b3e71a9c',
  userPoolId: 'eu-west-1_CpuSA9Ajj',
  clientId: '2qg73bt6binqftkm9hpd8557j0',
  //backendapi: 'http://localhost:5000',
  backendapi: 'http://34.242.130.245:5000/',
  //backendapi: 'https://pl73xmcmr4.execute-api.eu-west-1.amazonaws.com/dev',
  firebase: {
    apiKey: 'AIzaSyCT1jDBwjNk-WVcF48RudyRFVZys7fpJtw',
    authDomain: 'yosso-4f9e1.firebaseapp.com',
    databaseURL: 'https://yosso-4f9e1.firebaseio.com',
    projectId: 'yosso-4f9e1',
    storageBucket: 'yosso-4f9e1.appspot.com',
    messagingSenderId: '967010760047'
  },
  frontendlink: 'http://localhost:4200',
  buyerendlink: 'https://yossobuyer.ascentic.se',
  // stripeKey: 'pk_test_xKhTEltHLKaCU3LrrSt9imD0'
  stripeKey: 'pk_test_kzlsf6cMTPIaatxhWpXeEXBG',
  googlemapapikey: 'AIzaSyBKvg9U5lTyVuQRmbhoWfwK_tK0KjxtiUU',
  VERSION: require('../../package.json').version,
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts